import { Stack, Text } from '@fluentui/react';

import { commaNumber } from '../../../../NumberField';
import { useFormSummary } from '../utils';

export default () => {
  const summary = useFormSummary();
  const isAlerted = summary.unpaidTotal !== 0;

  const style = { color: isAlerted ? "red" : "unset" };

  return (
    <Stack horizontal>
      <Text variant="xLarge" style={style}>
        Kalan Bakiye:
      </Text>
      <Stack grow horizontalAlign="end">
        <Text variant="xLarge" style={style}>
          {commaNumber(summary.unpaidTotal)} TL
        </Text>
      </Stack>
    </Stack>
  );
};
